import ChangePassword from "../model/ChangePassword";
import CurrentUserDetails from "../model/CurrentUserDetails";

// Load current user details

export const LOAD_CURRENT_USER_TYPE = "LOAD_CURRENT_USER";

export interface LoadCurrentUserAction {
  type: typeof LOAD_CURRENT_USER_TYPE;
}

export const loadCurrentUser = (): LoadCurrentUserAction => {
  return { type: LOAD_CURRENT_USER_TYPE };
};

// Current user details loaded

export const CURRENT_USER_LOADED_TYPE = "CURRENT_USER_LOADED";

export interface CurrentUserLoadedAction {
  type: typeof CURRENT_USER_LOADED_TYPE;
  user: CurrentUserDetails;
}

export const currentUserLoaded = (
  currentUser: CurrentUserDetails
): CurrentUserLoadedAction => {
  return {
    type: CURRENT_USER_LOADED_TYPE,
    user: currentUser,
  };
};

// Current User Load Error

export const CURRENT_USER_LOAD_ERROR_TYPE = "CURRENT_USER_LOAD_ERROR";

export interface CurrentUserLoadErrorAction {
  type: typeof CURRENT_USER_LOAD_ERROR_TYPE;
  error: string;
}

export const currentUserLoadError = (error: string): CurrentUserLoadErrorAction => {
  return {
    type: CURRENT_USER_LOAD_ERROR_TYPE,
    error: error,
  };
};

// Update user details

export const UPDATE_CURRENT_USER_TYPE = "UPDATE_CURRENT_USER";

export interface UpdateCurrentUserAction {
  type: typeof UPDATE_CURRENT_USER_TYPE;
}

export const updateCurrentUser = (): UpdateCurrentUserAction => {
  return { type: UPDATE_CURRENT_USER_TYPE };
};

// Current User Details Updated

export const CURRENT_USER_UPDATED_TYPE = "CURRENT_USER_UPDATED_TYPE";

export interface CurrentUserDetailsUpdatedAction {
  type: typeof CURRENT_USER_UPDATED_TYPE;
  user: CurrentUserDetails;
}

export const currentUserDetailsUpdated = (
  currentUser: CurrentUserDetails
): CurrentUserDetailsUpdatedAction => ({
  type: CURRENT_USER_UPDATED_TYPE,
  user: currentUser,
});

// Current User Update Error

export const CURRENT_USER_UPDATE_ERROR_TYPE = "CURRENT_USER_UPDATE_ERROR";

export interface CurrentUserUpdateErrorAction {
  type: typeof CURRENT_USER_UPDATE_ERROR_TYPE;
  error: string;
}
export const currentUserUpdateError = (error: string): CurrentUserUpdateErrorAction => {
  return {
    type: CURRENT_USER_UPDATE_ERROR_TYPE,
    error: error,
  };
};

// Current User Change Password Request

export const CURRENT_USER_CHANGE_PASSWORD_TYPE = "CURRENT_USER_CHANGE_PASSWORD";
export interface CurrentUserChangePasswordAction {
  type: typeof CURRENT_USER_CHANGE_PASSWORD_TYPE;
  password: ChangePassword;
  message: string;
}

export const currentUserChangePassword = (
  password: ChangePassword,
  message: string
): CurrentUserChangePasswordAction => {
  return {
    type: CURRENT_USER_CHANGE_PASSWORD_TYPE,
    password: password,
    message: message,
  };
};

// Current User Change Password Failure
export const CURRENT_USER_CHANGE_PASSWORD_FAILURE_TYPE =
  "CURRENT_USER_CHANGE_PASSWORD_FAILURE";
export interface CurrentUserChangePasswordFailureAction {
  type: typeof CURRENT_USER_CHANGE_PASSWORD_FAILURE_TYPE;
  error: string;
}

export const currentUserChangePasswordFailure = (
  error: string
): CurrentUserChangePasswordFailureAction => {
  return {
    type: CURRENT_USER_CHANGE_PASSWORD_FAILURE_TYPE,
    error: error,
  };
};

// Current User Password Changed

export const CURRENT_USER_PASSWORD_CHANGED_TYPE = "CURRENT_USER_PASSWORD_CHANGED";

export interface CurrentUserPasswordChangedAction {
  type: typeof CURRENT_USER_PASSWORD_CHANGED_TYPE;
  success: string;
}

export const currentUserPasswordChanged = (
  success: string
): CurrentUserPasswordChangedAction => ({
  type: CURRENT_USER_PASSWORD_CHANGED_TYPE,
  success: success,
});

// Link Benchmark Engineer

export const LINK_BENCHMARK_ENGINEER_TYPE = "LINK_BENCHMARK_ENGINEER";

export interface LinkBenchmarkEngineerAction {
  type: typeof LINK_BENCHMARK_ENGINEER_TYPE;
  engineerUuid: string;
}

export const linkBenchmarkEngineer = (engineerUuid: string): LinkBenchmarkEngineerAction => {
  return {
    type: LINK_BENCHMARK_ENGINEER_TYPE,
    engineerUuid,
  };
};

// Benchmark Engineer Linked

export const BENCHMARK_ENGINEER_LINKED_TYPE = "BENCHMARK_ENGINEER_LINKED";

export interface BenchmarkEngineerLinkedAction {
  type: typeof BENCHMARK_ENGINEER_LINKED_TYPE;
  user: CurrentUserDetails;
}

export const benchmarkEngineerLinked = (user: CurrentUserDetails): BenchmarkEngineerLinkedAction => {
  return {
    type: BENCHMARK_ENGINEER_LINKED_TYPE,
    user,
  };
};

// Link Benchmark Engineer Error

export const LINK_BENCHMARK_ENGINEER_ERROR_TYPE = "LINK_BENCHMARK_ENGINEER_ERROR";

export interface LinkBenchmarkEngineerErrorAction {
  type: typeof LINK_BENCHMARK_ENGINEER_ERROR_TYPE;
  error: string;
}

export const linkBenchmarkEngineerError = (error: string): LinkBenchmarkEngineerErrorAction => {
  return {
    type: LINK_BENCHMARK_ENGINEER_ERROR_TYPE,
    error,
  };
};

// Unlink Benchmark Engineer

export const UNLINK_BENCHMARK_ENGINEER_TYPE = "UNLINK_BENCHMARK_ENGINEER";

export interface UnlinkBenchmarkEngineerAction {
  type: typeof UNLINK_BENCHMARK_ENGINEER_TYPE;
}

export const unlinkBenchmarkEngineer = (): UnlinkBenchmarkEngineerAction => {
  return {
    type: UNLINK_BENCHMARK_ENGINEER_TYPE,
  };
};

// Benchmark Engineer Unlinked

export const BENCHMARK_ENGINEER_UNLINKED_TYPE = "BENCHMARK_ENGINEER_UNLINKED";

export interface BenchmarkEngineerUnlinkedAction {
  type: typeof BENCHMARK_ENGINEER_UNLINKED_TYPE;
  user: CurrentUserDetails;
}

export const benchmarkEngineerUnlinked = (user: CurrentUserDetails): BenchmarkEngineerUnlinkedAction => {
  return {
    type: BENCHMARK_ENGINEER_UNLINKED_TYPE,
    user,
  };
};

// Unlink Benchmark Engineer Error

export const UNLINK_BENCHMARK_ENGINEER_ERROR_TYPE = "UNLINK_BENCHMARK_ENGINEER_ERROR";

export interface UnlinkBenchmarkEngineerErrorAction {
  type: typeof UNLINK_BENCHMARK_ENGINEER_ERROR_TYPE;
  error: string;
}

export const unlinkBenchmarkEngineerError = (error: string): UnlinkBenchmarkEngineerErrorAction => {
  return {
    type: UNLINK_BENCHMARK_ENGINEER_ERROR_TYPE,
    error,
  };
};

// Toggle Time Period View
export const TOGGLE_TIME_PERIOD_VIEW_TYPE = "TOGGLE_TIME_PERIOD_VIEW";

export interface ToggleTimePeriodViewAction {
  type: typeof TOGGLE_TIME_PERIOD_VIEW_TYPE;
  showRecentOnly: boolean;
}

export const toggleTimePeriodView = (showRecentOnly: boolean): ToggleTimePeriodViewAction => {
  return {
    type: TOGGLE_TIME_PERIOD_VIEW_TYPE,
    showRecentOnly,
  };
};

export const CURRENT_USER_TIME_PERIOD_CHANGED_TYPE = "CURRENT_USER_TIME_PERIOD_CHANGED";

export interface CurrentUserTimePeriodChangedAction {
  type: typeof CURRENT_USER_TIME_PERIOD_CHANGED_TYPE;
  user: CurrentUserDetails;
}

export const currentUserTimePeriodChanged = (
  user: CurrentUserDetails
): CurrentUserTimePeriodChangedAction => ({
  type: CURRENT_USER_TIME_PERIOD_CHANGED_TYPE,
  user,
});

// Update existing type exports at the bottom
type CurrentUserAction =
  | LoadCurrentUserAction
  | CurrentUserLoadedAction
  | CurrentUserLoadErrorAction
  | CurrentUserDetailsUpdatedAction
  | UpdateCurrentUserAction
  | CurrentUserUpdateErrorAction
  | CurrentUserChangePasswordAction
  | CurrentUserChangePasswordFailureAction
  | CurrentUserPasswordChangedAction
  | LinkBenchmarkEngineerAction
  | BenchmarkEngineerLinkedAction
  | LinkBenchmarkEngineerErrorAction
  | UnlinkBenchmarkEngineerAction
  | BenchmarkEngineerUnlinkedAction
  | UnlinkBenchmarkEngineerErrorAction
  | ToggleTimePeriodViewAction
  | CurrentUserTimePeriodChangedAction;

export default CurrentUserAction;
